import * as XLSX from "sheetjs-style";

export function exportToExcel(data: any[], filename: string, sheetName: string = "Reservations") {
    if (data.length === 0) return;

    const headers = Object.keys(data[0]);
    const rows = data.map(row => headers.map(key => row[key]));
    const sheetData = [headers, ...rows];

    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

    // 🔹 Bold header row
    headers.forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: colIndex });
        if (worksheet[cellRef]) {
            worksheet[cellRef].s = {
                font: { bold: true }
            };
        }
    });

    // 🔹 Auto column widths
    worksheet["!cols"] = headers.map((key, index) => {
        const maxLen = Math.max(
            key.length,
            ...rows.map(r => (r[index] ? r[index].toString().length : 0))
        );
        return { wch: maxLen + 2 };
    });

    // 🔹 Correctly define sheet range
    worksheet["!ref"] = XLSX.utils.encode_range({
        s: { r: 0, c: 0 },
        e: { r: sheetData.length - 1, c: headers.length - 1 }
    });

    // 🔹 Freeze top row
    worksheet["!sheetViews"] = [
        {
            state: "frozen",
            ySplit: 1,
            topLeftCell: "A2",
            activePane: "bottomLeft"
        }
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    XLSX.writeFile(workbook, filename, { cellStyles: true });
}
